import axios from "axios";

export async function fetchVideoBySlug(slug) {
  return await axios
    .get(`/videos/${slug}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchAdvisorWelcomeVideo() {
  return await axios
    .get(`/videos/advisor-welcome-video`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function logPageVisit(
  payload = { funnel_type: null, funnel_step: null, affiliate_code: null }
) {
  return await axios
    .post("/visits", payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function storeMedia(payload = null) {
  return await axios
    .post("/upload-media", payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function youtubeLiveCall() {
  return await axios
    .get("/videos/live-call")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function getAllRoles() {
  return await axios
    .get("/admin-courses/roles")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}
